<template>
    <div class="main-container">
        <div class="header-action-bar p-3 d-flex justify-content-end">
            <b-button variant="primary" size="md" @click="addnew" class="px-4 rounded-pill shadow-sm">
                <b-icon icon="plus" class="mr-1"></b-icon> ເພີ່ມໃໝ່
            </b-button>
        </div>

        <div class="content-body px-3">
            <b-card no-body class="border-0 shadow-sm mb-4">
                <div class="p-3">
                    <b-row align-v="center">
                        <b-col md="3" class="mb-2 mb-md-0">
                            <b-form-select v-model="field" :options="findfied" class="border-light rounded-pill"></b-form-select>
                        </b-col>
                        <b-col md="6" class="mb-2 mb-md-0">
                            <b-form-input v-model="find" placeholder="ຄົ້ນຫາຂໍ້ມູນທີ່ນີ້..." class="border-light rounded-pill"></b-form-input>
                        </b-col>
                        <b-col md="3 text-right">
                            <b-button variant="primary" block @click="onSearch" class="rounded-pill px-4">
                                <b-icon icon="search" class="mr-2"></b-icon> ຄົ້ນຫາ
                            </b-button>
                        </b-col>
                    </b-row>
                </div>
            </b-card>

            <b-card no-body class="border-0 shadow-sm overflow-hidden">
                <b-table hover :fields="fields" :items="items" responsive="sm" class="mb-0 custom-table" head-variant="white">
                    <template #cell(index)="data">
                        <span class="text-muted font-weight-bold">{{ data.index + 1 }}</span>
                    </template>
                    <template #cell(action)="data">
                        <div class="d-flex justify-content-center">
                            <b-button variant="light" size="sm" class="mr-2 text-primary" @click="edit(data.item.id)">
                                <b-icon icon="pencil-square"></b-icon>
                            </b-button>
                            <b-button variant="light" size="sm" class="text-danger" @click="del(data.item.id)">
                                <b-icon icon="trash"></b-icon>
                            </b-button>
                        </div>
                    </template>
                </b-table>
            </b-card>
        </div>

        <infinite-loading @infinite="infiniteHandler" spinner="spiral">
            <div slot="spinner">Loading...</div>
            <div slot="no-more">No more data</div>
            <div slot="no-results">No results data</div>
        </infinite-loading>
    </div>

</template>

<script>
import axios from "axios";
import InfiniteLoading from "vue-infinite-loading";

export default {

    data() {
        return {
            page: 0,
            field: '',
            find: '',
            menuid: this.$route.query.id,
            pkey: "",
            table: "",
            fields: [],
            items: [],
            findfied: [],
            menu: [],
            user:[]
        }
    },
    components: {
        InfiniteLoading,
    },
    filters: {
        format(number) {
            let amt = new Intl.NumberFormat('en-US', { maximumSignificantDigits: 3 }).format(number)
            return amt
        },
    },
    created() {

        let login = localStorage.getItem("Login");
        this.user = JSON.parse(login);
        axios
            .get(
                this.$store.getters.getBaseUrl + "/dynamic_table/" + this.menuid + "?offset=0&fld=" + this.field + "&find=" + this.find +'&branch_id='+this.user.branch_id
            )
            .then((response) => {
                // JSON responses are automatically parsed.
                this.menu = response.data.menu
                this.pkey = response.data.pkey
                this.table = response.data.table
                this.fields = JSON.parse(response.data.fields)
                this.items = response.data.items
                this.fields.forEach((item) => {
                    this.findfied.push({
                        value: item.key,
                        text: item.label
                    })
                })

            })
            .catch((e) => {
                console.log(e);
            });



    },
    methods: {
        goback() {
            this.$router.go(-1)
        },
        format(number) {
            let amt = new Intl.NumberFormat('en-US', { maximumSignificantDigits: 3 }).format(number)
            return amt
        },
        padTo2Digits(num) {
            return num.toString().padStart(2, '0');
        },

        formatDate(dd) {
            let d=new Date(dd)
            return [
                this.padTo2Digits(d.getDate()),
                this.padTo2Digits(d.getMonth() + 1),
                d.getFullYear(),
            ].join('/');
        },
        infiniteHandler($state) {
            this.busy = true;
            setTimeout(() => {

                axios
                    .get(
                        this.$store.getters.getBaseUrl +
                        "/dynamic_table/" + this.menuid +
                        "?offset=" + this.page + "&fld=" + this.field + "&find=" + this.find
                    )

                    .then((response) => {
                        //this.pkey=response.data.pkey
                        if (this.page == 0) {
                            // this.fields = JSON.parse(response.data.fields)

                            // this.fields.forEach((item) => {
                            //     this.findfied.push({
                            //         value: item.key,
                            //         text: item.label
                            //     })
                            // })

                            this.items = response.data.items;
                            this.page++;
                        } else {

                            if (response.data.items.length != 0) {
                                this.page++;
                                this.items = this.items.concat(response.data.items);
                            }
                            $state.complete();
                        }
                    });
                $state.loaded();
                this.busy = false;
            }, 200);
        },

        onSearch() {
            axios
                .get(
                    this.$store.getters.getBaseUrl + "/dynamic_table/" + this.menuid + "?offset=0&" + "&fld=" + this.field + "&find=" + this.find +'&branch_id='+this.user.branch_id
                )
                .then((response) => {
                    // JSON responses are automatically parsed.
                    this.items = response.data.items;
                    this.page = 0;

                })
                .catch((e) => {
                    console.log(e);
                });
        },
        addnew() {
            this.$router.push(this.menu.formnew_web + this.$route.query.id);
        },
        edit(id) {
            //  console.log(this.rowSlect[0].doc_code);
            //  const Values = Object.values(this.rowSlect[0]);
            this.$router.push(
                this.menu.formedit_web  +
                this.$route.query.id +
                "/" +
                this.pkey +
                "/" +
                id
            );
        },
        del(code) {

            let params = {
                table: this.table,
                pkey: this.pkey,
                code: code
            }
            this.$bvModal.msgBoxConfirm('ກະລຸນາຢືນຢັນ ທ່ານຕ້ອງການລົບລາຍການນີອອກຈາກລະບົບ.', {
                title: 'Please Confirm',
                size: 'md',
                buttonSize: 'sm',
                okVariant: 'danger',
                okTitle: 'YES',
                cancelTitle: 'NO',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            })
                .then(value => {
                    if (value == true) {
                        axios.post(this.$store.getters.getBaseUrl + '/del', params)
                            .then((res) => {
                                if (res.data.code == 1) {
                                    this.$bvToast.toast(`ລົບລາຍການອອກສຳເລັດແລ້ວ.`, {
                                        title: 'ຂໍ້ຄວາມແຈ້ງກັບ...',
                                        autoHideDelay: 5000,
                                        appendToast: true
                                    })

                                    axios
                                        .get(
                                            this.$store.getters.getBaseUrl + "/dynamic_table/" + this.menuid + "?offset=0&fld=" + this.field + "&find=" + this.find +'&branch_id='+this.user.branch_id
                                        )
                                        .then((response) => {
                                            // JSON responses are automatically parsed.
                                            this.pkey = response.data.pkey
                                            this.table = response.data.table
                                            this.fields = JSON.parse(response.data.fields)
                                            this.items = response.data.items
                                            this.fields.forEach((item) => {
                                                this.findfied.push({
                                                    value: item.key,
                                                    text: item.label
                                                })
                                            })

                                        })
                                        .catch((e) => {
                                            console.log(e);
                                        });

                                    this.page = 0

                                } else {
                                    this.$bvToast.toast(res.data.msg, {
                                        title: 'ຂໍ້ຄວາມແຈ້ງກັບ...',
                                        autoHideDelay: 5000,
                                        appendToast: true
                                    })



                                }
                                console.log(res.data)
                            })
                            .catch(err => {

                                console.error(err);
                            })
                    }
                    //this.boxTwo = value
                })
                .catch(err => {
                    console.error(err);
                })

        }
    },

}
</script>

<style scoped>
.main-container {
    background-color: #f8f9fa;
    min-height: 100vh;
    padding-bottom: 50px;
}
.custom-table th {
    background-color: #fdfdfd !important;
    color: #6c757d;
    text-transform: uppercase;
    font-size: 0.85rem;
    letter-spacing: 0.5px;
    border-top: none !important;
}
.rounded-pill {
    border-radius: 50px !important;
}
</style>